export interface LoginReports {
    loginAt: number;
}

export interface Roles {
  reader: boolean;
  author?: boolean;
  admin?:  boolean;
  superadmin?: boolean;
}
export class User {
  account:string;
  active: boolean;
  status: boolean;
  email:    string;
  displayName: string;
  isAnonymous: boolean;
  phone:  string;
  photoURL: string;
  uid: string;
  //balance: number;
  fonction: string;
  background: string;
  createdAt: number = new Date().getTime();
  roles:    Roles;
  last_logins: LoginReports;
  isRegistered: boolean;
  isSecretSet: boolean;
  constructor(authData) {
    this.account = authData.account || 'useraccount'
    this.email    = authData.email || ''
    this.uid = authData.uid || ''
    this.photoURL = authData.photoURL || ''
    this.phone   = authData.phone || ''
    this.fonction   = authData.fonction || 'autre'
    this.displayName = authData.displayName || authData.name || ''
    this.status = true
    this.active = authData.active || true
    this.background = this.getRandomColor();
    this.isAnonymous = authData.isAnonymous || false
    this.createdAt = new Date().getTime()
    //this.balance = 0
    this.isRegistered = true;
    this.isSecretSet = false;
    this.roles    = { reader: true , author: true}  // admin: false, superadmin: false
    this.last_logins = { loginAt : new Date().getTime() }
  }

  getRandomColor(): string {
    const letters = '0123456789ABCDEF'.split('');
    let color = '#';
    for ( let i = 0; i < 6; i++ ) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

}



// WEBPACK FOOTER //
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/src/app/models/user.ts